// Event Module
import { collection, doc } from "firebase/firestore";
import { db } from "../../firebase/firebase.js";

export const eventsCollection = collection(db, "meetings");

export const eventDoc = (id) => doc(db, "meetings", id);